import { i18nFilter, translate } from "app/filters/i18nFilter";
import { abbrNumberVisitsFilter, percentageSignFilter, roundNumberFilter } from "app/filters/ngFilters";
import frameStates from "app/components/React/widgetFrames/frameStates";
import type { FC } from "react";
import SimpleFrame from "app/components/React/widgetFrames/simpleFrame";
import { TableTopOverview } from "app/components/React/TableTopOverview/TableTopOverview";
import type { ITableTopOverviewItem } from "app/components/React/TableTopOverview/TableTopOverviewTypes";

const i18n = i18nFilter();
const percentageFilter = percentageSignFilter();
const abbrNumberVisits = abbrNumberVisitsFilter();

const getTableOverviewItems = ({
    organic,
    paid,
    total,
    percentage,
    webSource,
    dashboard = false,
    filters,
    isLoading,
}): ITableTopOverviewItem[] => {
    filters = filters || {};

    const {
        ExcludeTerms,
        IncludeTerms,
        IncludeOrganic,
        IncludePaid,
        IncludeBranded,
        IncludeNoneBranded,
        IncludeNewKeywords,
        IncludeTrendingKeywords,
        IncludeQuestions,
        source,
        family,
        limits,
    } = filters;
    const showPercentageFromDesktopVisits =
        ExcludeTerms ||
        IncludeTerms ||
        IncludeOrganic ||
        IncludePaid ||
        IncludeBranded ||
        IncludeNoneBranded ||
        IncludeNewKeywords ||
        IncludeTrendingKeywords ||
        IncludeQuestions ||
        source ||
        family ||
        limits ||
        dashboard;

    const items: ITableTopOverviewItem[] = [
        {
            value: roundNumberFilter()(total),
            text:
                webSource === "Desktop"
                    ? translate("analysis.source.search.keywords.header.searchvisits")
                    : translate("analysis.source.search.keywords.header.searchvisits.mobile"),
            tooltipContent: translate("keyword.overview.total.tooltip"),
            tooltipEnabled: !total,
            isLoading,
        },
    ];

    if (showPercentageFromDesktopVisits) {
        items.push({
            value: percentageFilter(percentage),
            text:
                webSource === "Desktop"
                    ? translate("analysis.source.search.keywords.header.searchvisitsprecentage")
                    : translate("analysis.source.search.keywords.header.searchvisitsprecentage.mobile"),
            itemAttributes: { "data-automation": "percents-from-total-searches" },
            tooltipContent: translate("keyword.overview.mobile.search.tooltip"),
            tooltipEnabled: !percentage,
            isLoading,
        });
    }

    if (webSource === "Desktop") {
        items.push({
            value: abbrNumberVisits(organic),
            textAttributes: {
                dangerouslySetInnerHTML: {
                    __html: i18n("analysis.source.search.keywords.header.organic"),
                },
            },
            itemAttributes: { "data-automation": "organic-search-keywords" },
            isLoading,
        });

        items.push({
            value: abbrNumberVisits(paid),
            textAttributes: {
                dangerouslySetInnerHTML: {
                    __html: i18n("analysis.source.search.keywords.header.paid"),
                },
            },
            itemAttributes: { "data-automation": "paid-search-keywords" },
            isLoading,
        });
    }

    return items;
};

export const KeywordsOverviewHeader: FC<any> = (props) => {
    const { isFetching, noData, dashboard, filters } = props;
    const isLoading = isFetching;
    const state = frameStates.Loaded;
    if (noData) {
        return null;
    }

    const items = getTableOverviewItems({ ...props, isLoading, dashboard, filters });

    return (
        <SimpleFrame
            state={state}
            onError={false}
            className="keywords-table-overview-single"
            onLoaded={
                <TableTopOverview
                    isLoading={isLoading}
                    items={items}
                    isDashboard={dashboard}
                    containerAttributes={{ "data-automation": "search-keywords-overview" }}
                />
            }
        />
    );
};
